
<div class="flex">
    <img src="{{data.image}}" alt="" class="flex-none w-14 h-14 rounded-full object-cover mr-4" loading="lazy" decoding="async">
    <h2 class="text-2xl font-semibold">{{data.name}}</h2>
</div>
<div class="flex-auto mt-2">
    <div class="text-base text-slate-900 font-semibold dark:text-slate-200">
        @if(data.email) {
        <a href="mailto:{{data.email}}" class="text-primary-500">Email: {{data.email}}</a>
        }
    </div>
    <div class="mt-0.5 dark:text-slate-300">
        @if(data.phone) {
        <p class="text-primary-500">Contact: {{data.phone}}</p>
        }
    </div>
    <div class="mt-0.5 dark:text-slate-300">
        @if(data.phoneAfterHours) {
        <p class="text-primary-500">Contact after hours: {{data.phoneAfterHours}}</p>
        }
    </div>
    <button class="bg-accent-500 text-white px-4 py-2 rounded mt-2" (click)="closeModal()">Close</button>
</div>